/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Qr_HintInputs */



/**
* | output |
* | --- |
* | "Point camera at a VDB deck QR code" |
*
* @param {Deck_Upload_Qr_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_qr_hint = /** @type {((inputs?: Deck_Upload_Qr_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Qr_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pointez la caméra vers un QR code de deck VDB")
	if (locale === "es") return /** @type {LocalizedString} */ ("Apunte la cámara al código QR de un deck VDB")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aponte a câmera para o código QR de um deck VDB")
	if (locale === "it") return /** @type {LocalizedString} */ ("Puntare la fotocamera verso un codice QR di un deck VDB")
	return /** @type {LocalizedString} */ ("Point camera at a VDB deck QR code")
});